import styled from "styled-components";
import {
  BUTTON_SIZES,
  IconClose,
  IconButton,
  SideSheetContainer,
} from "@cdkglobal/radial";
import { JsonSchemaItemProperty, RenderInputTypeParams } from "../../../../../types";
import {
  InputsWrapper,
  RecordPageFieldLayout,
} from "../../../../../utils/styled";

const FlexSideSheetContainer = styled(SideSheetContainer)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 100vh;
  padding: ${({ isCollapsed }) => (isCollapsed ? "0rem" : "0.5rem")};
  position: fixed;
  right: -0.25rem;
  z-index: 1000;
`;

interface RenderCorrelationRowSideSheetProps {
  isSideSheetCollapsed: boolean;
  closeSideSheet: () => void;
  selectedRowIndex: number | null;
  properties: Record<string, JsonSchemaItemProperty>;
  rowScopedProperties?: Record<number, Record<string, JsonSchemaItemProperty>>;
  renderInputType: (params: RenderInputTypeParams) => JSX.Element;
}

export default function RenderCorrelationRowSideSheet({
  isSideSheetCollapsed,
  closeSideSheet,
  selectedRowIndex,
  properties,
  rowScopedProperties,
  renderInputType,
}: Readonly<RenderCorrelationRowSideSheetProps>): JSX.Element {
  return (
    <FlexSideSheetContainer
      isCollapsed={isSideSheetCollapsed}
      isModal={true}
      width={isSideSheetCollapsed ? "0px" : "620px"}
      dataTestId="correlation-row-side-sheet"
    >
      <IconButton
        icon={<IconClose />}
        size={BUTTON_SIZES.SMALL}
        text="Close"
        onClick={closeSideSheet}
        style={{ alignSelf: "flex-end", marginBottom: "1rem" }}
      />

      {selectedRowIndex !== null && (
        <InputsWrapper>
          {Object.entries(properties).map(([propertySubKey, item]) => {
            const isHidden =
              rowScopedProperties?.[selectedRowIndex]?.[propertySubKey]
                ?.isHidden ?? item.isHidden;

            if (isHidden) {
              return null;
            }

            return (
              <RecordPageFieldLayout key={propertySubKey}>
                {renderInputType({rowIndex: selectedRowIndex, propertySubKey, itemProperty: item})}
              </RecordPageFieldLayout>
            );
          })}
        </InputsWrapper>
      )}
    </FlexSideSheetContainer>
  );
}
